import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from '../../../shared/store'
import {
  login as loginAction,
  register as registerAction,
  logout as logoutAction,
  resetPassword as resetPasswordAction,
  clearError,
} from '../../../shared/store/slices/authSlice'
import type { LoginCredentials, RegisterCredentials } from '../services/authService'

/**
 * Custom hook for authentication
 * Provides auth state and actions
 */
export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>()
  const auth = useSelector((state: RootState) => state.auth)

  return {
    // State
    user: auth.user,
    session: auth.session,
    isAuthenticated: auth.isAuthenticated,
    passwordRecovery: auth.passwordRecovery,
    isLoading: auth.isLoading,
    error: auth.error,
    role: auth.role,
    sessionVersion: auth.sessionVersion,

    // Actions
    login: (credentials: LoginCredentials) => dispatch(loginAction(credentials)),
    register: (credentials: RegisterCredentials) => dispatch(registerAction(credentials)),
    logout: () => dispatch(logoutAction()),
    resetPassword: (email: string) => dispatch(resetPasswordAction(email)),
    clearError: () => dispatch(clearError()),

    // Computed values
    isAdmin: auth.role === 'admin',
    isArborist: auth.role === 'arborist',
    isClient: auth.role === 'client',
  }
}
